import React, { Component } from 'react'
import { observer } from 'mobx-react'
import * as R from 'ramda'
import { v4 as uuidv4 } from 'uuid'
import Select from '../form/Select'
import Checkbox from '../form/Checkbox'
import DashboardWizardStore from './creationWizard/DashboardWizardStore'
import TreeviewSelect from '../form/TreeviewSelect'

@observer
class QuadrantHeader extends Component {
    constructor(props) {
        super(props)
        const { dashStore, widget } = props
        const { appStore } = dashStore
        const {
            respondentType, productType, surveyType, industry,
        } = widget
        this.dashboardWizardStore = new DashboardWizardStore(appStore, dashStore)
        this.dashboardWizardStore.newWidget = {
            ...this.dashboardWizardStore.newWidget,
            respondentType,
            productType,
            surveyType,
            industry,
        }

        this.init()
        this.state = {
            loading: true,
        }
    }

    init = async () => {
        await this.dashboardWizardStore.init()
        await Promise.all([
            this.dashboardWizardStore.getQuestions(true),
            this.dashboardWizardStore.getKpis(),
        ])
        this.setState({ loading: false })
    }

    changeQuestion = (index, question) => {
        const { widget } = this.props
        const newMultiQuestion = [...widget.multiQuestion]
        if (question.value === 'null') {
            newMultiQuestion.splice(index, 1)
        } else {
            newMultiQuestion[index] = question
        }
        const newWidget = { ...widget, multiQuestion: newMultiQuestion }

        this.updateWidget(newWidget)
    }

    changeDisplayLabels=(displayLabels) => {
        const { widget } = this.props
        const newWidget = {
            ...widget,
            widgetRenderSettings: { ...widget.widgetRenderSettings, showLabels: displayLabels },
        }

        this.updateWidget(newWidget)
    }

    changeColouredBy = (colouredBy) => {
        const { widget } = this.props
        const newWidget = {
            ...widget,
            widgetRenderSettings: { ...widget.widgetRenderSettings, colouredBy },
        }

        this.updateWidget(newWidget)
    }

    changeFilter = (newFilter) => {
        const { widget } = this.props
        const newWidget = {
            ...widget,
            filter: newFilter,
        }

        this.updateWidget(newWidget)
    }

    updateWidget = async (newWidget) => {
        const { dashStore, widget } = this.props
        const { updateWidget, getChartData } = dashStore
        const widgets = R.pathOr([{}], ['widgets'], dashStore)
        const widgetIndex = widgets.findIndex((w) => w.key === widget.key)

        updateWidget(widgetIndex, newWidget)
        dashStore.widgets = await getChartData([...widgets.slice()])
    }

    render() {
        const { loading } = this.state
        const { getQuadrantQuestions } = this.dashboardWizardStore
        const { widget, dashStore } = this.props
        const { createTreeData, appStore } = dashStore
        const { multiQuestion } = widget
        const isMultiDivision = R.path(['userData', 'flags', 'isMultiDivision'], appStore)
        const colouredByOptions = [
            { value: 'portfolio', label: 'Portfolio' },
            { value: 'product', label: 'Product' },
            { value: 'year', label: 'Year' },
        ]
        if (loading) return <div style={{ height: '56px' }} />
        const quadrantQuestions = getQuadrantQuestions(false)
        return (
            <div className="quadrantHeader">
                <Select
                    label="X-Axis"
                    name="xAxis"
                    options={quadrantQuestions}
                    defaultValue={R.pathOr(undefined, [0, 'value'], multiQuestion)}
                    isOptionSelected={(option, selectValue) => (
                        option.value === R.pathOr(undefined, [0, 'value'], selectValue)
                        && R.pathOr(undefined, [0, 'group'], selectValue) === option.group
                    )}
                    onBlur={(v) => this.changeQuestion(0, v)}
                    indentation
                    showSelected
                />
                <Select
                    label="Y-Axis"
                    name="yAxis"
                    options={quadrantQuestions}
                    defaultValue={R.pathOr(undefined, [1, 'value'], multiQuestion)}
                    isOptionSelected={(option, selectValue) => (
                        option.value === R.pathOr(undefined, [0, 'value'], selectValue)
                        && R.pathOr(undefined, [0, 'group'], selectValue) === option.group
                    )}
                    onBlur={(v) => this.changeQuestion(1, v)}
                    indentation
                    showSelected
                />
                <Select
                    label="Bubble Size"
                    options={[{ value: 'null', label: 'None' }, ...quadrantQuestions]}
                    defaultValue={R.pathOr('null', [2, 'value'], multiQuestion)}
                    isOptionSelected={(option, selectValue) => (
                        option.value === R.pathOr(undefined, [0, 'value'], selectValue)
                        && R.pathOr(undefined, [0, 'group'], selectValue) === option.group
                    )}
                    onBlur={(v) => this.changeQuestion(2, v)}
                    name="zAxis"
                    indentation
                    showSelected
                />
                <Select
                    label="Coloured By"
                    options={isMultiDivision ? [{ value: 'division', label: 'Division' }, ...colouredByOptions] : colouredByOptions}
                    defaultValue={R.pathOr('year', ['widgetRenderSettings', 'colouredBy'], widget)}
                    onBlur={({ value }) => this.changeColouredBy(value)}
                    name="colouredBy"
                />
                <TreeviewSelect
                    cssClass="formControl"
                    label="Filter"
                    options={createTreeData(
                        R.pathOr([], ['scope'], widget),
                        R.pathOr([], ['filter'], widget),
                    )}
                    returnDeepNested
                    name="filter"
                    onBlur={({ value }) => {
                        this.changeFilter(value)
                    }}
                    numSelected={R.pathOr([], ['filter'], widget).length}
                    style={{ marginTop: '25px' }}
                />
                <Checkbox
                    label="Display Labels"
                    defaultChecked={R.pathOr(false, ['widgetRenderSettings', 'showLabels'], widget)}
                    onBlur={({ value }) => this.changeDisplayLabels(value)}
                />

            </div>
        )
    }
}

export default QuadrantHeader
